/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const EnvironmentType = zod.enum(['production', 'sandbox']);

export type EnvironmentType = zod.input<typeof EnvironmentType>;
export type EnvironmentTypeOutput = zod.output<typeof EnvironmentType>;
